/** @module SiteAdmin/ValidateForm */
define([
	"dojo/_base/declare",
	"csi/utility/validateUtility",
	"csi/form/Widget",
	"csi/locale"
], function(declare, validateUtility, Widget, locale) {

	return declare(Widget, {

		/**
		 * Validates the Enumeration Value to be Alphanumeric.
		 * @param {View} formView
		 */
		onValidateNonNumericValue: function(formView) {
			if (validateUtility.isNumeric(formView.getFieldValue("Node Name"))) {
				throw new Error(locale.resource("CustomAttribute_ErrorEnumNotAlphanumeric"));
			}
		}

	});
});
